"use strict";

exports.__esModule = true;
exports["default"] = exports.TotalCount = exports.TertiaryNavMobile = exports.TertiaryNavDesktop = exports.Link = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _styles = require("@qc-modules/styles");

var _elements = require("../glyphs/elements");

var _glyph = _interopRequireDefault(require("../cta/glyph"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _arrow = _interopRequireDefault(require("../slider/arrow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Link = _styledComponents["default"].a.withConfig({
  displayName: "tertiary-nav__Link",
  componentId: "sc-1amdn5r-0"
})(["display:block;color:", ";fill:", ";text-decoration:none;"], function (props) {
  return (0, _styles.colors)(props.textColor, props);
}, function (props) {
  return (0, _styles.colors)(props.textColor, props);
});

exports.Link = Link;

var TotalCount = _styledComponents["default"].span.withConfig({
  displayName: "tertiary-nav__TotalCount",
  componentId: "sc-1amdn5r-1"
})(["opacity:0.5;"]);

exports.TotalCount = TotalCount;
var propTypesMobile = {
  activeIndex: _propTypes.number,
  length: _propTypes.number,
  next: (0, _propTypes.shape)({
    mlid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    path: _propTypes.string,
    plid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  }),
  parentPath: _propTypes.string,
  parentTitle: _propTypes.string,
  previous: (0, _propTypes.shape)({
    mlid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    path: _propTypes.string,
    plid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  }),
  textColor: _propTypes.string
};

var TertiaryNavMobile = function TertiaryNavMobile(_ref) {
  var activeIndex = _ref.activeIndex,
      length = _ref.length,
      next = _ref.next,
      previous = _ref.previous,
      parentTitle = _ref.parentTitle,
      parentPath = _ref.parentPath,
      textColor = _ref.textColor;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    display: ["flex", "flex", "none"],
    justifyContent: "space-between",
    px: [2, 2, 1],
    py: [2, 2, 1],
    style: {
      position: "absolute",
      right: 0,
      top: 0
    },
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    href: parentPath,
    textColor: textColor
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    as: "span",
    color: textColor,
    fontSize: 4,
    fontWeight: 1,
    lineHeight: [2, 2, 3, 3, 2, 2]
  }, /*#__PURE__*/_react["default"].createElement(_glyph["default"], {
    height: 16,
    mr: 1,
    width: 16
  }, /*#__PURE__*/_react["default"].createElement(_elements.NavArrowUp, null)), parentTitle)), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    lineHeight: [2, 2, 3, 3, 2, 2]
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    href: previous ? previous.path : null,
    isActive: Boolean(previous),
    textColor: textColor
  }, /*#__PURE__*/_react["default"].createElement(_glyph["default"], {
    height: 16,
    mx: 2,
    width: 16
  }, /*#__PURE__*/_react["default"].createElement(_elements.NavArrowLeft, null))), activeIndex ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: textColor,
    fontSize: [3, 3, 4, 4, 4],
    fontWeight: 1,
    lineHeight: [2, 2, 3, 3, 2, 2],
    textAlign: "center"
  }, activeIndex, " ", /*#__PURE__*/_react["default"].createElement(TotalCount, null, "/", length)) : null, /*#__PURE__*/_react["default"].createElement(Link, {
    href: next ? next.path : null,
    isActive: Boolean(next),
    textColor: textColor
  }, /*#__PURE__*/_react["default"].createElement(_glyph["default"], {
    height: 16,
    mx: 2,
    width: 16
  }, /*#__PURE__*/_react["default"].createElement(_elements.NavArrowRight, null)))));
};

exports.TertiaryNavMobile = TertiaryNavMobile;
TertiaryNavMobile.propTypes = propTypesMobile;
var propTypesDesktop = {
  activeIndex: _propTypes.number,
  length: _propTypes.number,
  next: (0, _propTypes.shape)({
    mlid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    path: _propTypes.string,
    plid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  }),
  previous: (0, _propTypes.shape)({
    mlid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    path: _propTypes.string,
    plid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  }),
  textColor: _propTypes.string
};

var TertiaryNavDesktop = function TertiaryNavDesktop(_ref2) {
  var activeIndex = _ref2.activeIndex,
      length = _ref2.length,
      previous = _ref2.previous,
      next = _ref2.next,
      textColor = _ref2.textColor;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    display: ["none", "none", "flex"]
  }, activeIndex ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    px: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: textColor,
    fontSize: 4,
    fontWeight: 1,
    lineHeight: [2, 2, 3, 3, 2, 2],
    textAlign: "center"
  }, activeIndex, " ", /*#__PURE__*/_react["default"].createElement(TotalCount, null, "/", length))) : null, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    px: 1
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    href: previous ? previous.path : null,
    isActive: Boolean(previous),
    textColor: textColor
  }, /*#__PURE__*/_react["default"].createElement(_arrow["default"], {
    color: textColor,
    direction: "left",
    isActive: Boolean(previous)
  }))), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    px: 1
  }, /*#__PURE__*/_react["default"].createElement(Link, {
    href: next ? next.path : null,
    isActive: Boolean(next),
    textColor: textColor
  }, /*#__PURE__*/_react["default"].createElement(_arrow["default"], {
    color: textColor,
    direction: "right",
    isActive: Boolean(next)
  }))));
};

exports.TertiaryNavDesktop = TertiaryNavDesktop;
TertiaryNavDesktop.propTypes = propTypesDesktop;
var propTypes = {
  activeIndex: _propTypes.number,
  darkUi: _propTypes.bool,
  length: _propTypes.number,
  next: (0, _propTypes.shape)({
    mlid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    path: _propTypes.string,
    plid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  }),
  parent: (0, _propTypes.shape)({
    mlid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    path: _propTypes.string,
    plid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    title: _propTypes.string
  }),
  previous: (0, _propTypes.shape)({
    mlid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    path: _propTypes.string,
    plid: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  }),
  textColor: _propTypes.string
};

var TertiaryNav = function TertiaryNav(_ref3) {
  var activeIndex = _ref3.activeIndex,
      darkUi = _ref3.darkUi,
      length = _ref3.length,
      next = _ref3.next,
      parent = _ref3.parent,
      previous = _ref3.previous,
      textColor = _ref3.textColor;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    justifyContent: "flex-end",
    px: [2, 2, 1],
    py: [2, 2, 1],
    r: 0,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(TertiaryNavDesktop, {
    activeIndex: activeIndex,
    darkUi: darkUi,
    length: length,
    next: next,
    previous: previous,
    textColor: textColor
  }), /*#__PURE__*/_react["default"].createElement(TertiaryNavMobile, {
    activeIndex: activeIndex,
    length: length,
    next: next,
    parentPath: parent.path,
    parentTitle: parent.title,
    previous: previous,
    textColor: textColor
  }));
};

TertiaryNav.propTypes = propTypes;
TertiaryNav.displayName = "Modules.TertiaryNav";
var _default = TertiaryNav;
exports["default"] = _default;